import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { getThemeChildrenClass } from '../Theme/ThemePresentation.js';
import { hostClass } from './Footer.styles.js';

var defaultProps = {
  previousTheme: "light"
};
var FooterPresentation = fComp(function (props) {
  var _cleanupClassObject, _cleanupClassObject2;

  var id = props.id,
      children = props.children,
      className = props.className,
      noMargin = props.noMargin,
      contactArea = props.contactArea,
      previousTheme = props.previousTheme,
      isStencilHost = props.isStencilHost;
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject)),
    isStencilHost: isStencilHost
  }, contactArea && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: getThemeChildrenClass(previousTheme)
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "__contact-area-outlier")
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-contact-area")
  }, contactArea)), /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-inner"), true), _defineProperty(_cleanupClassObject2, getThemeChildrenClass("dark", "footer"), true), _cleanupClassObject2))
  }, children));
}, defaultProps);

export { FooterPresentation, defaultProps };
